import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {ReportDeliveryState} from "@/interfaces/state/reportdelivery";
import {IdMapper} from "@/interfaces/state/base";
import {ReportDelivery} from "@/interfaces/entity/reportdelivery";
import {PaginationMeta} from "@/interfaces/common";
import {ReportDeliveryParams} from "@/modules/reportdelivery/params";
import store from "@/store"
import {union} from 'lodash';
import {
    createReportDelivery,
    listReportDelivery,
    singleReportDelivery,
    updateReportDelivery
} from "@/modules/reportdelivery/service";

@Module({dynamic: true, name: "reportDelivery", store})
class ReportDeliveryModule extends VuexModule implements ReportDeliveryState {
    data: IdMapper<ReportDelivery> = {};
    ids: string[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ReportDeliveryParams = new ReportDeliveryParams();

    get reportDeliveries() {
        return this.ids.map((id: string) => this.data[id]);
    }

    @Mutation
    private MAP_REPORT_DELIVERY(payload: any) {
        const idMapper: IdMapper<ReportDelivery> = {}
        this.meta = payload.meta;
        this.ids = payload.datas?.map((reportDelivery: ReportDelivery, index) => {
            idMapper[reportDelivery.rowGuid] = {...reportDelivery, stt: index + 1} as any
            return reportDelivery.rowGuid
        })
        this.data = idMapper
    }

    @Mutation
    private ADD_REPORT_DELIVERY(payload: ReportDelivery) {
        if (!payload || this.ids.includes(payload.rowGuid) || this.data[payload.rowGuid]) return;
        this.ids = union(this.ids, [payload.rowGuid])
        this.data[payload.rowGuid] = payload
    }

    @Mutation
    private UPDATE_REPORT_DELIVERY_PARAMS(payload: any) {
        this.params = payload
    }

    @Mutation
    private UPDATE_REPORT_DELIVERY(payload: ReportDelivery) {
        if (!this.data[payload.rowGuid] || !this.ids.includes(payload.rowGuid)) return;
        this.data[payload.rowGuid] = {...payload}
    }

    @Action({rawError: true})
    public async singleReportDelivery(id: string) {
        const { data } = await singleReportDelivery(id)
        return data.data;
    }

    @Action({rawError: true})
    public async updateReportDelivery(dataReq: any) {
        const {data} = await updateReportDelivery(dataReq.rowGuid, dataReq)
        this.UPDATE_REPORT_DELIVERY(data.data)
    }
    @Action({rawError: true})
    public async listReportDelivery(params: ReportDeliveryParams = new ReportDeliveryParams()) {
        const {data} = await listReportDelivery(params)
        this.MAP_REPORT_DELIVERY(data)
    }

    @Action({rawError: true})
    public async createReportDelivery(form: any){
        const {data} = await createReportDelivery(form)
        this.ADD_REPORT_DELIVERY(data.data)
    }

    @Action
    public updateReportDeliveryParams(payload: any){
        this.UPDATE_REPORT_DELIVERY_PARAMS(payload)
    }
}

export const ReportDeliveryStore = getModule(ReportDeliveryModule);
